import type { ComponentProps, ComponentRef } from 'react';
import { forwardRef } from 'react';

import { CaretDownIcon } from '~components/icons/CaretDownIcon';
import { Button } from '~modules/media-library/view/Button';

export const SelectButton = forwardRef<ComponentRef<typeof Button>, Omit<ComponentProps<typeof Button>, 'variant'>>(
  function SelectButton({ children, className, ...ButtonProps }, ref) {
    return (
      <Button className={`ml--select-button ${!!className ? className : ''}`} {...ButtonProps} ref={ref}>
        {children}
        {!ButtonProps.disabled && <CaretDownIcon className="w-4 h-4 -mr-2 ml-1" />}
      </Button>
    );
  },
);
